import React, { useEffect, useState } from "react";
import { api } from "../api";

/**
 * Lightweight live sparkline pulling /api/sparkline/{kpi}.
 * Color: derived from comparing first/last value (up vs down).
 */
export default function Sparkline({ kpi, invert = false, height = 32, refreshMs = 3500 }) {
  const [pts, setPts] = useState([]);
  useEffect(() => {
    let alive = true;
    const fetchIt = async () => {
      try {
        const d = await api.sparkline(kpi, 30);
        if (alive) setPts(d.data || []);
      } catch { /* */ }
    };
    fetchIt();
    const id = setInterval(fetchIt, refreshMs);
    return () => { alive = false; clearInterval(id); };
  }, [kpi, refreshMs]);

  if (pts.length < 2) {
    return <svg className="spark flat" viewBox="0 0 100 32" height={height}>
      <path d="M0,16 L100,16" />
    </svg>;
  }
  const vals = pts.map(p => p.v);
  const min = Math.min(...vals);
  const max = Math.max(...vals);
  const range = (max - min) || 1;
  const w = 100;
  const h = 32;
  const path = pts.map((p, i) => {
    const x = (i / (pts.length - 1)) * w;
    const y = h - ((p.v - min) / range) * (h - 4) - 2;
    return `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(" ");

  const direction = vals[vals.length - 1] - vals[0];
  let cls = "flat";
  if (Math.abs(direction) / (max || 1) > 0.005) {
    // For some KPIs, "up" is bad (leakage, h2_intensity). invert flips meaning.
    const up = direction > 0;
    cls = invert ? (up ? "up" : "down") : (up ? "down" : "up");
  }

  return (
    <svg className={`spark ${cls}`} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" height={height}>
      <path d={path} />
    </svg>
  );
}
